export const GET_ME = 'GET_ME';
export const SET_ME = 'SET_ME';
export const SET_USER_LOCKED = 'SET_USER_LOCKED';

export const SET_ME_LOADING_FALSE = 'SET_ME_LOADING_FALSE';

export const GET_ORGANIZATION_MEMBERS = 'GET_ORGANIZATION_MEMBERS';
export const SET_ORGANIZATION_MEMBERS = 'SET_ORGANIZATION_MEMBERS';

export const SET_ORGANIZATION_MEMBERS_LOADING_FALSE = 'SET_ORGANIZATION_MEMBERS_LOADING_FALSE';

export const SET_USER_RESTRICTION = 'SET_USER_RESTRICTION';
